import {Component, forwardRef, Input, Optional} from "@angular/core";
import {SearchAction, SearchActionSelector} from "../../search/search-grid/actions/search-action.component";
import {ReportGenerationService} from "../report-generation.service";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";

/**
 * Search action to generate a report from the search page. The ReportModel needs to be provided on the SearchPage
 * component using the provideReportModel(...) method
 */
@Component({
    selector: "wbo-report-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => ReportSearchActionComponent),
            multi: true
        }
    ]
})
export class ReportSearchActionComponent implements SearchAction {

    /**
     * Name of the column that has the Id
     */
    @Input() idColumn: string;

    /**
     * Report class when showing the report page in a dialog
     */
    @Input() reportComponent: any;

    constructor(@Optional() private reportModel: ReportModel<any>,
                private reportGenerationService: ReportGenerationService,
                private stackedPageService: FUIStackedPageService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 60;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "reports";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.report.search.action.report";
    }

    async doAction(data: any): Promise<void> {
        if (this.reportComponent) {
            this.stackedPageService.open(this.reportComponent, {[this.idColumn]: data[this.idColumn]});
        } else {
            this.reportModel.data[this.idColumn] = data[this.idColumn];
            await this.reportGenerationService.execute(this.reportModel);
        }
    }

    isAvailable(data: any): boolean {
        return true;
    }
}
